import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faSortUp, faSortDown,    } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import {Loader, Spinner} from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import Search from '../Components/Search';

const RulesList = () => {
    const  [customers , setCustomers] = useState ([]);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate()
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [retryFunction, setRetryFunction] = useState(null);
  const [selectedCustomers, setSelectedCustomers] = useState([]); // Add this state
  const [selectAll, setSelectAll] = useState(false); // Add this state
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const fetchUrl = process.env.REACT_APP_FORE_BUILDCOINS;


  // Add tooltip state
  const [tooltip, setTooltip] = useState({
    show: false,
    content: '',
    x: 0,
    y: 0
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'DRAFT':
        return 'text-gray-500';
      case 'INVOICED':
        return 'text-green-500';
      case 'SENT':
        return 'text-blue-500';
      default:
        return '';
    }
  };

  const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [rewardRules, setRewardRules] = useState([]);
  
  console.log(filteredCustomers);
const searchTypes = ['Reward Criteria', 'Reward Rule'];

  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedArray = [...customers].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
    setCustomers(sortedArray);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
    }
    return null;
  };

  useEffect(() => {
    handleSearch();
  }, [rewardRules]);

const handleSearch = (query, type) => {
  if (!query || !type) {
    setFilteredCustomers(rewardRules);
    return;
  }

  const filtered = rewardRules.filter((rule) => {
    const lowercaseQuery = query.toLowerCase();
    switch (type) {
      case 'Reward Criteria':
        // Updated mapping for new schema structure
        return rule.rewardCriteria?.rewardCriteria?.some(criteria => 
          criteria.name?.toLowerCase().includes(lowercaseQuery)
        );
      case 'Reward Rule':
        // Check if any reward rule name matches the query
        return rule.rewardRules?.some(rewardRule => 
          rewardRule.name?.toLowerCase().includes(lowercaseQuery)
        );
      default:
        return false;
    }
  });

  setFilteredCustomers(filtered);
};

  
 
  useEffect(() => {
    fetchRewardRules();
 
  // Add event listener for the custom refresh event
  const handleRefresh = () => {
    setIsLoading(true);
    fetchRewardRules();
  };
  
  window.addEventListener('refreshTemplateList', handleRefresh);
  
  // Clean up the event listener when component unmounts
  return () => {
    window.removeEventListener('refreshTemplateList', handleRefresh);
  };
}, []);

  const fetchRewardRules = async (attempt = 1) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(fetchUrl + "rules/all", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      
      console.log(data?.data)
      if (data?.data) {
        setRewardRules(data?.data); // Update productCategories state
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchRewardRules(attempt + 1), 1000); // Retry after 1 second
      } else {
       
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchRewardRules(attempt)); // Set retry function
      }
    }finally {
      setIsLoading(false);
    }
  };

// if (isLoading) {
//   return <Loader />;
// }


 // Tooltip functions
  const showTooltip = (content, event) => {
    setTooltip({
      show: true,
      content: content,
      x: event.clientX + 10,
      y: event.clientY + 10
    });
  };

  const hideTooltip = () => {
    setTooltip({
      show: false,
      content: '',
      x: 0,
      y: 0
    });
  };

  const updateTooltipPosition = (event) => {
    if (tooltip.show) {
      setTooltip(prev => ({
        ...prev,
        x: event.clientX + 10,
        y: event.clientY + 10
      }));
    }
  };

// Updated format functions for new schema
const formatCriteriaTooltip = (rule) => {
  const criteria = rule?.rewardCriteria?.rewardCriteria;
  if (!criteria || !Array.isArray(criteria) || criteria.length === 0) return 'No criteria data';
  
  return (
    <div className="text-left">
      <div className="font-semibold mb-2">Criteria Details:</div>
      {criteria.map((criteriaItem, index) => (
        <div key={index} className="mb-3 p-2 border-b border-gray-600 last:border-b-0">
          <div><strong>Name:</strong> {criteriaItem.name}</div>
          <div className="mt-1"><strong>Conditions:</strong></div>
          {criteriaItem.conditions?.map((condition, condIndex) => (
            <div key={condIndex} className="ml-2">
              • {condition.field} {condition.operator} {condition.value}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const formatRewardTooltip = (rule) => {
  const rewards = rule?.rewardRules;
  if (!rewards || rewards.length === 0) return 'No reward data';
  
  return (
    <div className="text-left">
      <div className="font-semibold mb-2">Reward Rules:</div>
      {rewards.map((reward, index) => (
        <div key={index} className="mb-2">
          <div><strong>Name:</strong> {reward.name}</div>
          <div><strong>Type:</strong> {reward.reward?.type}</div>
          <div><strong>Value:</strong> {reward.reward?.value}</div>
          <div><strong>Apply:</strong> {reward.reward?.apply?.join(', ')}</div>
        </div>
      ))}
    </div>
  );
};

const formatApplicabilityTooltip = (rule) => {
  const applicability = rule?.applicabilityRules;
  if (!applicability || applicability.length === 0) return 'No applicability data';
  
  return (
    <div className="text-left">
      <div className="font-semibold mb-2">Applicability Rules:</div>
      {applicability.map((app, index) => (
        <div key={index} className="mb-2">
          <div><strong>Name:</strong> {app.name}</div>
          <div><strong>Conditions:</strong></div>
          {app.conditions?.map((condition, condIndex) => (
            <div key={condIndex} className="ml-2">
              • {condition.field} {condition.operator} {condition.value}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

// Updated redemption tooltip for new schema
const formatRedemptionTooltip = (rule) => {
  const redemption = rule?.redemptionRules;
  if (!redemption || redemption.length === 0) return 'No redemption data';
  
  return (
    <div className="text-left">
      <div className="font-semibold mb-2">Redemption Rules:</div>
      {redemption.map((red, index) => (
        <div key={index} className="mb-2">
          <div><strong>Name:</strong> {red.name}</div>
          <div><strong>Type:</strong> {red.redeem?.type}</div>
          <div><strong>Value:</strong> {red.redeem?.value}</div>
          <div><strong>Apply:</strong> {red.redeem?.apply?.join(', ')}</div>
        </div>
      ))}
    </div>
  );
};

// Updated expiry tooltip for new schema
const formatExpiryTooltip = (rule) => {
  const expiry = rule?.expiryRules;
  if (!expiry || expiry.length === 0) return 'No expiry data';
  
  return (
    <div className="text-left">
      <div className="font-semibold mb-2">Expiry Rules:</div>
      {expiry.map((exp, index) => (
        <div key={index} className="mb-2">
          <div><strong>Name:</strong> {exp.name}</div>
          <div><strong>Type:</strong> {exp.expiry?.type}</div>
          <div><strong>Value:</strong> {exp.expiry?.value}</div>
          {exp.conditions && exp.conditions.length > 0 && (
            <>
              <div><strong>Conditions:</strong></div>
              {exp.conditions.map((condition, condIndex) => (
                <div key={condIndex} className="ml-2">
                  • {condition.field} {condition.operator} {condition.value}
                </div>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

  const handleEdit = async (ruleId, attempt = 1) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${fetchUrl}rules/get?id=${ruleId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
  
      const data = await response.json();
      console.log("Template package data:", data.data);
  
      if (data.data) {
        navigate("/bb/app/rewardrules/editrewardrule", {
          state: {
            rewardRuleData: {
            ...data.data,
          }
        }
        });
        console.log('ruleId:', ruleId); 
        console.log("data:----",data.data)
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => handleEdit(ruleId,attempt + 1), 1000);
      } else {
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleEdit(ruleId, attempt));
      }
    }
  }; 

const handleCheckboxChange = (customer) => {
  if (selectedCustomers.includes(customer)) {
    setSelectedCustomers(selectedCustomers.filter((c) => c !== customer));
    setSelectAll(false); // Update selectAll state when deselecting a checkbox
  } else {
    setSelectedCustomers([...selectedCustomers, customer]);
    if (selectedCustomers.length === customers.length - 1) {
      setSelectAll(true); // Update selectAll state when selecting all checkboxes
    }
  }
};

const handleSelectAll = () => {
  if (selectAll) {
    setSelectedCustomers([]);
    setSelectAll(false);
  } else {
    setSelectedCustomers(customers);
    setSelectAll(true);
  }
};

const handleDelete = async (attempt = 1) => {
  const selectedCustomerIds = selectedCustomers.map((customer) => customer._id);
  try {
    const token = sessionStorage.getItem('token');
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `customer/delete-customers?customer_ids=${selectedCustomerIds}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });

    const data = await response.json();
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      // Update the customers state
      setCustomers(customers.filter((customer) => !selectedCustomerIds.includes(customer._id)));
      setSelectedCustomers([]);
      setSelectAll(false);
      
      // Show success popup
      setPopupMessage(data.message);
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        navigate("/bb/app/sales/customerslist")
      }, 3000); 
      // Fetch updated customer list
      //fetchCustomers();
    } else {
      console.log(data.message)
      setPopupMessage(data.message);
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }
  } catch (error) {
    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setTimeout(() => handleDelete(attempt + 1), 1000);
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleDelete(attempt));
    }
  }
};


const handleCreate = () => {
  navigate("/bb/app/rewardrules/newrewardrule");
};
 const handleNavigateCustomerDetails = (customer) =>{
  navigate("/bb/app/sales/customerdetails", {state:{CustomerData:customer}})
 }

const closePopup = () => {
  setShowPopup(false);
  setPopupMessage('');
  setPopupType('');
  setRetryFunction(null);
};

const Retry = async () => {
  console.log("Retry called");
  setIsLoading(true); // Show loader
  setTimeout(async () => {
    if (retryFunction) {
      await retryFunction();
    }
    setIsLoading(false); // Hide loader after retry
  }, 5000); // 5-second delay
  setShowPopup(false);
};

const handleRetry = () => {
  if (retryFunction) {
    retryFunction();
  }
  closePopup();
};

const BackToLoginPage = () => {
  console.log("Back To Login Page");
  setShowPopup(false);
  localStorage.removeItem('LoginData');
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('appId');
navigate('/bb');
};

if (isLoading) {
  return <Loader />;
}

  return (
    <div className=" bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
        <div className="flex w-full flex-row">
          <div className="w-full flex-1">
              <div className="flex flex-col w-full h-full justify-center items-center">
              <div className="w-full h-full flex flex-col justify-between ">
                   <div className="w-full h-16 border-b flex items-center">
                   <div className="flex w-full justify-between px-7 items-center">
  {selectedCustomers.length > 0 ? (
    <button onClick={handleDelete}
      className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md ">Delete</button>
  ) : (
    <>
    <div className='space-x-10 flex flex-row'>
      <h1 className="text-lg font-bold">All Reward Rules</h1>
      <Search onSearch={handleSearch} searchTypes={searchTypes} />
      </div>
      <button onClick={handleCreate}
        className="bg-[#E54643] text-white z-20 px-2 py-1 rounded"
        title="" data-tooltip="Create Template"  style={{ '--tooltip-bg': 'black' }}>+ New</button>
    </>
  )}
</div>
</div>
                  <div className="w-full h-full bg-white rounded-xs overflow-hidden ">
                  <div className="overflow-y-auto h-[80vh]">
  {rewardRules && rewardRules.length > 0 ? (
    <table className="w-full mb-2 table-fixed">
      <thead className="sticky top-0 bg-[#fafafc] text-[#6c7184] border-b">
        <tr className='border-b'>
          <th className="text-xs py-3 text-center w-[18%] px-2">Criteria</th>
          <th className="text-xs py-3 text-center w-[18%] px-2">Reward</th>
          <th className="text-xs py-3 text-center w-[18%] px-2">Applicability</th>
          <th className="text-xs py-3 text-center w-[18%] px-2">Redemption</th>
          <th className="text-xs py-3 text-center w-[18%] px-2">Expiry</th>
          <th className="text-xs py-3 text-center w-[10%] px-2">Actions</th>
        </tr>
      </thead>
<tbody className='border-b border-t'>
{rewardRules.map((rule) => {
    // Updated mapping for new schema structure
    
    // Criteria - now it's an array inside rewardCriteria.rewardCriteria
    const criteriaArray = rule?.rewardCriteria?.rewardCriteria || [];
    const firstCriteria = criteriaArray[0];
    const criteriaName = firstCriteria?.name || 'N/A';
    const criteriaCount = criteriaArray.length;
    
    // Reward Rules - structure remains similar
    const rewardName = rule?.rewardRules?.[0]?.name || 'N/A';
    const rewardType = rule?.rewardRules?.[0]?.reward?.type || 'N/A';
    const rewardValue = rule?.rewardRules?.[0]?.reward?.value || 'N/A';
    
    // Applicability Rules - structure remains similar
    const applicabilityName = rule?.applicabilityRules?.[0]?.name || 'N/A';
    
    // Redemption Rules - updated for new schema with redeem object
    const redemptionRule = rule?.redemptionRules?.[0];
    let redemptionName = 'N/A';
    let redemptionType = 'N/A';
    
    if (redemptionRule) {
      redemptionName = redemptionRule.name || 'N/A';
      if (redemptionRule.redeem) {
        redemptionType = `${redemptionRule.redeem.type}: ${redemptionRule.redeem.value}`;
        if (redemptionRule.redeem.apply && redemptionRule.redeem.apply.length > 0) {
          redemptionType += ` (${redemptionRule.redeem.apply.join(', ')})`;
        }
      }
    }
    
    // Expiry Rules - updated for new schema with expiry object
    const expiryRule = rule?.expiryRules?.[0];
    let expiryName = 'N/A';
    let expiryDetails = 'N/A';
    
    if (expiryRule) {
      expiryName = expiryRule.name || 'N/A';
      if (expiryRule.expiry) {
        expiryDetails = `${expiryRule.expiry.value} ${expiryRule.expiry.type}`;
      }
    }

    return (
      <tr key={`${rule._id}`} className="text-sm border-b hover:bg-gray-50">
          {/* Criteria Column - Updated for array structure */}
          <td 
            className="py-2 text-center cursor-help w-[18%] px-2"
            onMouseEnter={(e) => showTooltip(formatCriteriaTooltip(rule), e)}
            onMouseLeave={hideTooltip}
            onMouseMove={updateTooltipPosition}
          >
            <div className="flex flex-col truncate">
              <span className="font-medium">{criteriaName}</span>
              {criteriaCount > 1 && (
                <span className="text-xs text-gray-500">+{criteriaCount - 1} more</span>
              )}
            </div>
          </td>  
          
          {/* Reward Column - Enhanced display */}
          <td 
            className="py-2 text-center cursor-help w-[18%] px-2"
            onMouseEnter={(e) => showTooltip(formatRewardTooltip(rule), e)}
            onMouseLeave={hideTooltip}
            onMouseMove={updateTooltipPosition}
          >
            <div className="flex flex-col truncate">
              <span className="font-medium">{rewardName}</span>
              <span className="text-xs text-gray-500">{rewardType}: {rewardValue}</span>
            </div>
          </td>
          
          {/* Applicability Column */}
          <td 
            className="py-2 text-center cursor-help w-[18%] px-2"
            onMouseEnter={(e) => showTooltip(formatApplicabilityTooltip(rule), e)}
            onMouseLeave={hideTooltip}
            onMouseMove={updateTooltipPosition}
          >
            <div className="truncate">
              {applicabilityName}
            </div>
          </td>     
          
         {/* Redemption Column - Updated for new schema */}
        <td 
          className="py-2 text-center cursor-help w-[18%] px-2"
          onMouseEnter={(e) => showTooltip(formatRedemptionTooltip(rule), e)}
          onMouseLeave={hideTooltip}
          onMouseMove={updateTooltipPosition}
        >
          <div className="flex flex-col truncate">
            <span className="font-medium">{redemptionName}</span>
            <span className="text-xs text-gray-500">{redemptionType}</span>
          </div>
        </td>
        
        {/* Expiry Column - Updated for new schema */}
        <td 
          className="py-2 text-center cursor-help w-[18%] px-2"
          onMouseEnter={(e) => showTooltip(formatExpiryTooltip(rule), e)}
          onMouseLeave={hideTooltip}
          onMouseMove={updateTooltipPosition}
        >
          <div className="flex flex-col truncate">
            <span className="font-medium">{expiryName}</span>
            <span className="text-xs text-gray-500">{expiryDetails}</span>
          </div>
        </td>
        
        {/* Actions Column */}
        <td className="py-2 text-center w-[10%] px-2">
          <button
            className="text-[#EA011F] px-2 py-1 rounded"
            onClick={() => handleEdit(rule._id)}
          >
            Edit
          </button>
        </td>
      </tr>
    );
  })}
</tbody>

    </table>
  ) : (
    <>
      <div className="flex justify-center items-center mb-4">
        <h1 className="text-xl font-bold">Create New Reward Rule</h1>
      </div>
      <div className="flex justify-center items-center">
        <button className="bg-[#F7525A] text-white px-2 py-1 rounded-md" onClick={handleCreate}>
          Create
        </button>
      </div>
    </>
  )}
</div>


    </div>
              </div>
            </div>
          </div>
      {/*   </div> */}
      </div>
{/* Custom Tooltip */}
    {tooltip.show && (
      <div
        className="fixed z-50 bg-gray-800 text-white p-3 rounded-lg shadow-lg max-w-sm pointer-events-none"
        style={{
          left: `${tooltip.x}px`,
          top: `${tooltip.y}px`,
          transform: 'translate(-50%, -100%)',
          marginTop: '-10px'
        }}
      >
        <div className="text-sm">
          {typeof tooltip.content === 'string' ? (
            <div>{tooltip.content}</div>
          ) : (
            tooltip.content
          )}
        </div>
        {/* Tooltip arrow */}
        <div 
          className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
        ></div>
      </div>
    )}

    {/* Popup Messages */}
    {showPopup && popupType === '200' && (
      <Msg200or201 message={popupMessage} onClose={closePopup} />
    )}
    {showPopup && popupType === '204' && (
      <Msg204 message={popupMessage} onClose={closePopup} />
    )}
    {showPopup && popupType === '400' && (
      <Msg400 message={popupMessage} onClose={closePopup} />
    )}
    {showPopup && popupType === '401' && (
      <Msg401 message={popupMessage} onClose={closePopup} />
    )}
    {showPopup && popupType === '403' && (
      <Msg403 message={popupMessage} onClose={closePopup} />
    )}
    {showPopup && popupType === '500' && (
      <Msg500 message={popupMessage} onClose={closePopup} onRetry={handleRetry} />
    )}
      </div>
    
  );
};

export default RulesList;

